import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LeftBox from './LeftBox';
import { PageContainer, LeftContainer, RightContainer } from './style';
import RightBox from './RightBox';
import {
    swap,
    getWorkoutSummary,
    calculateTotalCalories,
    copyObject,
    lbsToKgs,
    isWorkoutEmpty,
    convertFormatToSeconds,
    convertFormatToHours,
    generateSlugLink,
    calculateSpeed,
    calculateDistance,
    convertTimeToFormat,
} from '../../../Utils';
import { generateRandomBackground } from '../../../Utils/workoutPlanBackgroundRandomizer';
import { merge, urlToFile } from '../../../Utils/mergeImages';
import { getCurrentFormattedDate } from '../../../Utils/timeConvertorHelper';
import { MobileContainer } from './MobileContainer';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { compose } from 'recompose';
import screenWidthProvider from '../HOCS/ScreenWidthProvider';
import { screenTypes } from '../../../Constants/screenTypes';
import { config } from '../../../Configurations';
import { WorkoutActionCreators } from '../../../Store/ActionCreators/WorkoutsActionCreators';
import { timeFormats } from '../../../Constants/timeFormats';
import TopMenu from '../../Components/TopMenu';
import { UserActionCreators } from '../../../Store/ActionCreators/UserActionCreators';

const REST_EXERCISE_ID = 276;

const rest = {
    MET_value: 1.5,
    bodyweightPercentage: '0%',
    distance: 'N/A',
    id: REST_EXERCISE_ID,
    isDistanceRequired: 0,
    kgs: 'N/A',
    name: 'Resting',
    orangeImage: '/storage/exercises/orange/orange-Icon-Exercise-Resting.imageset/orange-Icon-Exercise-Resting@3x.png',
    reps: 'N/A',
    time: '0',
    whiteImage: '/storage/exercises/white/Icon-Exercise-Resting.imageset/Icon-Exercise-Resting@3x.png',
};

class WorkoutPlan extends Component {
    state = {
        isEditWorkout: this.props.isEdit ? true : false,
        rounds: [[]],
        workoutType: 12,
        workoutTitle: 'Untitled workout',
        workoutDescription: null,
        imageBackground: '',
        settings: {
            editDefaults: false,
            repsPerSet: 10,
            setsPerExercise: 1,
            circuits: 1,
            intervalWorkout: false,
            duration: '00:01:00',
            setRestDuration: '00:00:45',
            roundRestDuration: '00:02:00',
        },
    };

    componentDidMount() {
        const {
            props: { getStockImage, getAuthenticatedUser, isEdit, workoutData },
            state: { workoutType },
            mapWorkoutData,
        } = this;

        if (handleLoginService.isAuthenticated() && !isEdit) {
            getAuthenticatedUser();
            getStockImage(workoutType);
        } else mapWorkoutData(workoutData);

        generateRandomBackground().then(background => this.setState({ imageBackground: { ...background } }));
    }

    mapWorkoutData = workoutData => {
        const { breakDowns } = workoutData;
        const tempBd = [...breakDowns];

        const rounds = [[]];

        // TODO: move to another file
        const isRoundWorkout = breakDowns.findIndex(exercise => exercise.is_round === true) === -1 ? false : true;
        if (isRoundWorkout) {
            for (let i = 0; i < breakDowns.length; i++) {
                const firstRoundIndex = tempBd.findIndex(exercise => exercise.is_round);
                tempBd.splice(firstRoundIndex, 1);

                const nextRoundIndex = tempBd.findIndex(exercise => exercise.is_round === true);
            }
        } else
            rounds[0] = breakDowns.map(bd => {
                bd.time = convertTimeToFormat(bd.timer_value);
                bd.setNumber = bd.set_number;
                bd.name = bd.exercise_name;
                bd.distance = bd.is_distance_required ? bd.distance : 'N/A';
                bd.kgs = bd.KG_count;
                bd.reps = bd.REPS_count;
                bd.calories = bd.calories_count;

                return bd;
            });

        this.setState({ rounds });
    };

    actions = {
        // Exercises
        addExercise: exercise => {
            const { rounds, workoutType, settings } = this.state;
            const { bodyweight } = this.props;

            rounds.forEach(round => {
                let newExercise = {},
                    exerciseCalories = 0,
                    restCalories = 0,
                    addPack = {};

                if (!settings.editDefaults) {
                    newExercise = copyObject(exercise);

                    if (newExercise.kgs === 'Bodyweight') newExercise.kgs = lbsToKgs(bodyweight);
                    exerciseCalories = calculateTotalCalories({
                        ...newExercise,
                        workoutType,
                        bodyweight,
                    });
                    newExercise.calories = exerciseCalories;
                    newExercise.speed = calculateSpeed(convertFormatToHours(newExercise.time), newExercise.distance);

                    round.push(newExercise);
                } else {
                    const { reps, ...restExercise } = exercise;
                    newExercise = { ...restExercise, reps: settings.repsPerSet };

                    exerciseCalories = calculateTotalCalories({
                        ...newExercise,
                        workoutType,
                        bodyweight,
                    });
                    newExercise.calories = exerciseCalories;
                    if (newExercise.kgs === 'Bodyweight') newExercise.kgs = lbsToKgs(bodyweight);

                    // define if we add only exercise or exercise with resting
                    addPack = { newExercise };

                    if (settings.intervalWorkout) {
                        newExercise.time = settings.duration;
                        exerciseCalories = calculateTotalCalories({
                            ...newExercise,
                            workoutType,
                            bodyweight,
                        });

                        newExercise.calories = exerciseCalories;
                        restCalories = calculateTotalCalories({ ...rest, workoutType, bodyweight });
                        rest.calories = restCalories;
                        rest.time = settings.setRestDuration;
                        newExercise.speed = calculateSpeed(
                            convertFormatToHours(newExercise.time),
                            newExercise.distance,
                        );

                        addPack = { newExercise, rest };
                    }

                    for (let i = 0; i < settings.setsPerExercise; i++) {
                        let newSet = copyObject(addPack);
                        newSet.newExercise.speed = calculateSpeed(
                            convertFormatToHours(newSet.newExercise.time),
                            newSet.newExercise.distance,
                        );
                        round.push(newSet.newExercise);
                        if (newSet.rest) round.push(newSet.rest);
                    }
                }
            });

            this.recalculateSetNumbers(rounds);
            this.setState({ rounds });
        },

        duplicateExercise: (roundIndex, exerciseIndex) => {
            let { rounds } = this.state;

            let newExercise = copyObject(rounds[roundIndex][exerciseIndex]);
            rounds[roundIndex].splice(exerciseIndex, 0, newExercise);

            this.recalculateSetNumbers(rounds);
            this.setState({ rounds });
        },

        deleteExercise: (roundIndex, exerciseIndex) => {
            let { rounds } = this.state;
            rounds[roundIndex].splice(exerciseIndex, 1);

            this.recalculateSetNumbers(rounds);
            this.setState({ rounds });
        },

        moveExerciseUp: (roundIndex, exerciseIndex) => {
            let { rounds } = this.state;

            if (exerciseIndex === 0) return;
            let newRound = swap(rounds[roundIndex], exerciseIndex, exerciseIndex - 1);
            rounds[roundIndex] = newRound;

            this.recalculateSetNumbers(rounds);
            this.setState({ rounds });
        },

        moveExerciseDown: (roundIndex, exerciseIndex) => {
            let { rounds } = this.state;

            if (exerciseIndex === rounds[roundIndex].length - 1) return;
            let newRound = swap(rounds[roundIndex], exerciseIndex, exerciseIndex + 1);
            rounds[roundIndex] = newRound;

            this.recalculateSetNumbers(rounds);
            this.setState({ rounds });
        },

        // Rounds
        addNewRound: () => {
            let { rounds } = this.state;
            const newRound = copyObject(rounds[rounds.length - 1]);
            rounds.push(newRound);

            this.setState({ rounds });
        },

        duplicateRound: index => {
            let { rounds } = this.state;
            const newRound = copyObject(rounds[index]);
            rounds.splice(index, 0, newRound);

            this.setState({ rounds });
        },

        deleteRound: index => {
            let { rounds } = this.state;
            rounds.splice(index, 1);

            if (rounds.length === 0) rounds.push([]);

            this.setState({ rounds });
        },

        moveRoundUp: index => {
            let { rounds } = this.state;

            if (index === 0) return;
            let newRounds = swap(rounds, index, index - 1);

            this.setState({ rounds: newRounds });
        },

        moveRoundDown: index => {
            let { rounds } = this.state;

            if (index === rounds.length - 1) return;
            let newRounds = swap(rounds, index, index + 1);

            this.setState({ rounds: newRounds });
        },

        // edit
        editExerciseValue: (roundIndex, exerciseIndex, event, duration) => {
            let { rounds, workoutType } = this.state;
            const { bodyweight } = this.props;

            let exercise = rounds[roundIndex][exerciseIndex];

            if (event) {
                if (event.target.name === 'speed')
                    exercise.distance = calculateDistance(convertFormatToHours(exercise.time), event.target.value);

                if (event.target.name === 'distance')
                    exercise.speed = calculateSpeed(convertFormatToHours(exercise.time), event.target.value);

                // let validatedValue = validateInputsInstantly(event);
                exercise[event.target.name] = event.target.value;
                // exercise[event.target.name] = validatedValue;
            }

            if (duration) {
                exercise.time = duration;

                if (exercise.isDistanceRequired) {
                    exercise.distance = calculateDistance(convertFormatToHours(exercise.time), exercise.speed);
                    exercise.speed = calculateSpeed(convertFormatToHours(exercise.time), exercise.distance);
                }
            }

            exercise.calories = calculateTotalCalories({ ...exercise, workoutType, bodyweight });

            rounds[roundIndex][exerciseIndex] = exercise;
            this.setState({ rounds });
        },

        editWorkoutFields: ({ target: { name, value } }) => {
            this.setState({ [name]: value });
        },

        submitWorkout: () => {
            const {
                state: {
                    imageBackground: { overlay, type: overlayType },
                    rounds,
                    workoutType,
                    workoutTitle,
                    workoutDescription,
                },
                props: { stockImage, uploadImage, createWorkout, fullName: userName, id: userId },
            } = this;

            // gathering workout data
            const summary = getWorkoutSummary(rounds);
            let workoutData = {
                total_REPS: summary.reps,
                total_KG_lifted: summary.weight,
                total_time: convertFormatToSeconds(summary.time),
                total_calories: summary.calories,
                total_distance: summary.distance,
                workout_type: workoutType,
                filter_type: overlayType,
                filter_layout: 0,
                title: workoutTitle,
                stock_image: stockImage,
                description: workoutDescription,
                planned: true,
                created_at: getCurrentFormattedDate(timeFormats.FULL_DATE_TIME),
                data: this.gartherExerciseData(rounds),
            };

            // TODO: move to a separate function
            // merging two images and sending to the server
            merge([overlay, `${config.baseUrl}/${stockImage}`]).then(b64 => {
                urlToFile(b64, 'WorkoutImage.png', 'img/png').then(file =>
                    uploadImage({ image: file }, imgPath => {
                        workoutData.image = imgPath;

                        createWorkout(workoutData, () => {
                            const redirectLink = `/planned`;
                            window.location.href = redirectLink;
                        });
                    }),
                );
            });
        },
    };

    formatExercisesData = exercise => {
        for (let prop in exercise) {
            if (exercise[prop] === 'N/A') exercise[prop] = null;
        }

        return exercise;
    };

    // Format exercises data to the format required by server
    gartherExerciseData = rounds => {
        let roundsData = [];
        const roundExercise = {
            id: REST_EXERCISE_ID,
            is_round: true,
        };

        rounds.forEach(round => {
            roundsData.push(copyObject(roundExercise));

            round.forEach(ex => {
                const exercise = this.formatExercisesData(ex);
                let exerciseData = {
                    id: exercise.id,
                    exercise_name: exercise.name,
                    exercise_img: exercise.whiteImage,
                    KG_count: exercise.kgs,
                    REPS_count: exercise.reps,
                    timer_value: convertFormatToSeconds(exercise.time),
                    exercise_type: exercise.type,
                    calories_count: exercise.calories,
                    distance: exercise.distance,
                    set_number: exercise.setNumber,
                    is_round: false,
                };

                roundsData.push(exerciseData);
            });
        });

        return roundsData;
    };

    modalActions = {
        selectWorkoutType: workoutType => {
            this.setState({ workoutType }, () => {
                this.recalculateCalories(this.state.workoutType);
                this.props.getStockImage(this.state.workoutType);
            });
        },

        addWorkoutDescription: workoutDescription => {
            this.setState({ workoutDescription });
        },

        defineWorkoutSettings: settings => {
            const { rounds, workoutType } = this.state;
            const { bodyweight } = this.props;

            this.setState({ settings });

            if (settings.editDefaults) {
                if (isWorkoutEmpty(rounds)) {
                    if (settings.circuits > 0) {
                        for (let i = 0; i < settings.circuits - 1; i++) {
                            rounds.push([]);
                        }
                    }
                } else {
                    if (rounds.length > settings.circuits) {
                        rounds.splice(settings.circuits - 1, rounds.length - settings.circuits);
                    }

                    if (rounds.length < settings.circuits) {
                        for (let i = 0; i <= settings.circuits - rounds.length; i++) {
                            rounds.push(copyObject(rounds[i]));
                        }
                    }
                }

                if (settings.intervalWorkout) {
                    let restExercise = copyObject(rest);
                    restExercise.time = settings.roundRestDuration;
                    let restCalories = calculateTotalCalories({
                        ...restExercise,
                        workoutType,
                        bodyweight,
                    });
                    restExercise.calories = restCalories;

                    rounds.forEach(round => round.push(copyObject(restExercise)));
                }
            }

            this.setState({ rounds });
        },
    };

    recalculateCalories = workoutType => {
        const { rounds } = this.state;
        const { bodyweight } = this.props;

        rounds.forEach(round => {
            round.forEach(exercise => {
                exercise.calories = calculateTotalCalories({
                    ...exercise,
                    workoutType,
                    bodyweight,
                });
            });
        });

        this.setState({ rounds });
    };

    recalculateSetNumbers = rounds => {
        let exerciseSetNumber = 1;
        let exercisesUsedIds = [];

        rounds.forEach(round => {
            round.forEach(exercise => {
                const currentExerciseId = exercise.id;

                if (!exercisesUsedIds.includes(currentExerciseId)) {
                    exercisesUsedIds.push(currentExerciseId);
                    let currentIdExercises = round.filter(ex => ex.id === currentExerciseId);
                    currentIdExercises.forEach(ex => (ex.setNumber = exerciseSetNumber++));
                    exerciseSetNumber = 1;
                }
            });

            exercisesUsedIds.splice(0, exercisesUsedIds.length);
        });
    };

    render() {
        const {
            state: { rounds, imageBackground, workoutType },
            props: { stockImageLoading, stockImage, screenWidth },
            actions: { submitWorkout },
        } = this;
        const summary = getWorkoutSummary(rounds);
        const workoutImageData = { stockImageLoading, stockImage, imageBackground };

        return (
            <div style={{ width: '100%' }}>
                <TopMenu />{' '}
                <PageContainer>
                    {screenWidth === screenTypes.MOBILE ? (
                        <MobileContainer />
                    ) : (
                        <Fragment>
                            <LeftContainer>
                                <LeftBox workoutType={workoutType} actions={this.actions} />
                            </LeftContainer>
                            <RightContainer>
                                <RightBox
                                    summary={summary}
                                    modalActions={this.modalActions}
                                    workoutImage={workoutImageData}
                                    actions={this.actions}
                                    disableSubmitButton={isWorkoutEmpty(rounds)}
                                    submitWorkout={submitWorkout}
                                    {...this.state}
                                />
                            </RightContainer>
                        </Fragment>
                    )}
                </PageContainer>
            </div>
        );
    }
}

const mapStateToProps = ({
    workout: {
        stockImage,
        statuses: { stockImageLoading },
    },
    user: {
        currentUser: { bodyweight, fullName, id },
    },
}) => ({
    stockImage,
    stockImageLoading,
    bodyweight,
    fullName,
    id,
});

const mapDispatchToProps = dispatch => ({
    getAuthenticatedUser: () => dispatch(UserActionCreators.getAuthenticatedUserRequest()),
    getStockImage: workoutType => dispatch(WorkoutActionCreators.getWorkoutStockImageRequest(workoutType)),
    uploadImage: (file, callback) => dispatch(WorkoutActionCreators.uploadWorkoutImageRequest(file, callback)),
    createWorkout: (workoutData, callback) =>
        dispatch(WorkoutActionCreators.createWorkoutRequest(workoutData, callback)),
});

export default compose(
    screenWidthProvider,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(WorkoutPlan);



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/index.js